import type { ReactNode } from 'react';

type IconProps = { className?: string };

const Svg = ({ className, children }: { className?: string; children: ReactNode }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.6}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    className={className}
  >
    {children}
  </svg>
);

const PROJECT_GLYPHS: Record<string, ReactNode> = {
  tipsytruck: (
    <>
      <path d="M6.5 5 L12 11 L17.5 5" />
      <path d="M12 11 V17.5" />
      <path d="M8.5 17.5 H15.5" />
      <circle cx="8" cy="3.4" r="0.9" fill="currentColor" stroke="none" />
      <circle cx="16" cy="3" r="0.9" fill="currentColor" stroke="none" />
    </>
  ),
  'memory-globe': (
    <>
      <circle cx="12" cy="12" r="7.5" />
      <ellipse cx="12" cy="12" rx="3.2" ry="7.5" />
      <path d="M4.6 12 H19.4" />
    </>
  ),
  'ai-ui-generator': (
    <>
      <path d="M7.5 7.5 L11.6 12 L7.5 16.5" />
      <path d="M13 16.5 H17" />
    </>
  ),
  'collab-canvas': <path d="M6 3.8 L6 17.6 L9.7 13.9 L12.5 19.8 L14.4 18.9 L11.7 13.1 L17.2 13.1 Z" />,
  'tipsy-configurator': (
    <>
      <path d="M12 2.6 L20.4 7.3 L20.4 16.7 L12 21.4 L3.6 16.7 L3.6 7.3 Z" />
      <path d="M12 12 L3.6 7.3" />
      <path d="M12 12 L20.4 7.3" />
      <path d="M12 12 L12 21.4" />
    </>
  ),
  'white-elephant': (
    <>
      <circle cx="12" cy="12" r="5.4" />
      <path d="M4.3 5.5 V18.5" />
      <path d="M19.7 5.5 V18.5" />
    </>
  ),
  'rust-fractal': (
    <>
      <circle cx="13.6" cy="12" r="5.6" />
      <circle cx="5.8" cy="12" r="2.8" />
    </>
  ),
  portfolio: (
    <>
      <path d="M4 5.5 H20 V18.5 H4 Z" />
      <path d="M4 9 H20" />
      <circle cx="6.7" cy="7.25" r="0.7" fill="currentColor" stroke="none" />
      <circle cx="9.2" cy="7.25" r="0.7" fill="currentColor" stroke="none" />
    </>
  ),
};

export const ProjectGlyph = ({ slug, className }: { slug: string; className?: string }) => (
  <Svg className={className}>{PROJECT_GLYPHS[slug] ?? PROJECT_GLYPHS.portfolio}</Svg>
);

export const GithubIcon = ({ className }: IconProps) => (
  <Svg className={className}>
    <path d="M9 19c-4.3 1.4-4.3-2.5-6-3m12 5v-3.5c0-1 .1-1.4-.5-2 2.8-.3 5.5-1.4 5.5-6a4.6 4.6 0 0 0-1.3-3.2 4.2 4.2 0 0 0-.1-3.2s-1.1-.3-3.5 1.3a12 12 0 0 0-6.2 0C6.5 2.8 5.4 3.1 5.4 3.1a4.2 4.2 0 0 0-.1 3.2A4.6 4.6 0 0 0 4 9.5c0 4.6 2.7 5.7 5.5 6-.6.6-.6 1.2-.5 2V21" />
  </Svg>
);

export const LinkedinIcon = ({ className }: IconProps) => (
  <Svg className={className}>
    <rect x="3" y="3" width="18" height="18" />
    <path d="M7 10.5 V17" />
    <path d="M7 7.15 V7.25" />
    <path d="M11 17 V13.2 A2.2 2.2 0 0 1 15.4 13.2 V17" />
    <path d="M11 17 V10.5" />
  </Svg>
);

export const MailIcon = ({ className }: IconProps) => (
  <Svg className={className}>
    <path d="M3.5 6 H20.5 V18 H3.5 Z" />
    <path d="M4 6.5 L12 12.5 L20 6.5" />
  </Svg>
);

export const ExternalIcon = ({ className }: IconProps) => (
  <Svg className={className}>
    <path d="M7 17 L17 7" />
    <path d="M9 7 H17 V15" />
  </Svg>
);

export const LanguageIcon = ({ className }: IconProps) => (
  <Svg className={className}>
    <circle cx="12" cy="12" r="8.4" />
    <path d="M3.6 12 H20.4" />
    <ellipse cx="12" cy="12" rx="3.6" ry="8.4" />
  </Svg>
);
